var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElectronicIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#DEEEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_850_4022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.3496 69.0701H34.0296C33.0796 69.0701 32.3096 68.3001 32.3096 67.3501V34.0301C32.3096 33.0801 33.0796 32.3101 34.0296 32.3101H67.3496C68.2996 32.3101 69.0696 33.0801 69.0696 34.0301V67.3501C69.0696 68.3001 68.2996 69.0701 67.3496 69.0701Z",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9004 32.31V23",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0898 32.31V23",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.29 32.31V23",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4805 32.31V23",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0703 36.8999H78.3803",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0703 46.0901H78.3803",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0703 55.29H78.3803",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0703 64.48H78.3803",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4805 69.0701V78.3801",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.29 69.0701V78.3801",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0898 69.0701V78.3801",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9004 69.0701V78.3801",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.31 36.8999H23",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.31 46.0901H23",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.31 55.29H23",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.31 64.48H23",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.48 59.88H45.89C45.28 59.88 44.7 59.64 44.27 59.21L42.17 57.11C41.74 56.68 41.5 56.1 41.5 55.49V45.9C41.5 45.29 41.74 44.71 42.17 44.28L44.27 42.18C44.7 41.75 45.28 41.51 45.89 41.51H55.48C56.09 41.51 56.67 41.75 57.1 42.18L59.2 44.28C59.63 44.71 59.87 45.29 59.87 45.9V55.49C59.87 56.1 59.63 56.68 59.2 57.11L57.1 59.21C56.67 59.64 56.09 59.88 55.48 59.88Z",
    fill: "#3078FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_850_4022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.38,
    height: 57.38,
    fill: "white",
    transform: "translate(22 22)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronicIcon);
export default __webpack_public_path__ + "static/media/electronic-icon.a6811a0aebbcf1a97fb230998473ffd6.svg";
export { ForwardRef as ReactComponent };